import React from 'react';
import { motion } from 'framer-motion';
import { SectionProps } from '../../types';

const Section: React.FC<SectionProps> = ({
                                             id,
                                             className = '',
                                             children,
                                             fullHeight = false,
                                             noPadding = false,
                                         }) => {
    const baseClasses = fullHeight ? 'min-h-screen' : '';
    const paddingClasses = noPadding ? '' : 'section-padding';

    return (
        <motion.section
            id={id}
            className={`${baseClasses} ${paddingClasses} ${className}`}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6, ease: 'easeOut' }}
        >
            <div className="container mx-auto container-padding">
                {children}
            </div>
        </motion.section>
    );
};

export default Section;